import React, { useState } from 'react';
import '../styles/footer.css';
import logo from '../assets/logo.png';

const Footer = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState('');

    const openModal = (content) => {
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <footer className="footer">
            <div className="footer-content">
                <img src={logo} alt="Better Sleeping Logo" className="footer-logo" />
                <div className="footer-links">
                    <button onClick={() => openModal('privacy')} className="footer-link-button">Privacy Policy</button>
                    <button onClick={() => openModal('terms')} className="footer-link-button">Terms of Service</button>
                    <button onClick={() => openModal('editorial')} className="footer-link-button">Editorial Standards</button>
                    <button onClick={() => openModal('disclaimer')} className="footer-link-button">Medical Disclaimer</button>
                    <a href="/contact">Contact Us</a>
                </div>
                <div className="footer-disclaimer">
                    Educational content only — not medical advice. Always consult a qualified healthcare professional about your sleep.
                </div>
                <div className="footer-copyright">
                    &copy; {new Date().getFullYear()} BetterSleep. All rights reserved.
                </div>
            </div>

            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={closeModal}>X</button>
                        {modalContent === 'privacy' && (
                            <section className="privacy-policy">
                                <h1>Privacy Policy</h1>
                                <h2>1. Introduction</h2>
    <p>We value your privacy and are committed to protecting your personal information. This Privacy Policy outlines what data we collect, why we collect it, and how it is used. By using our website, you agree to the practices described here.</p>
    
    <h2>2. Information We Collect</h2>
    <p>We may collect information that identifies you, including your name, email address, and other contact details, as well as non-identifying information, such as browser type, pages visited, and usage data. This information is gathered when you provide it directly (e.g., by signing up for newsletters) or automatically through cookies and similar technologies.</p>
    
    <h2>3. How We Use Your Information</h2>
    <p>We use your personal data to improve your experience on our website, respond to inquiries, send updates or marketing information, and improve our services based on usage data.</p>
    
    <h2>4. Sharing Your Information</h2>
    <p>We do not sell your personal information to third parties. We may share data with trusted partners to help us perform website operations or analytics, always under strict confidentiality agreements.</p>
    
    <h2>5. Your Rights</h2>
    <p>You have the right to access, correct, or delete your personal information. If you would like to manage your data or request deletion, please contact us at info@bettersleep.ing.</p>
    
    <h2>6. Security</h2>
    <p>We take reasonable steps to protect your data from unauthorized access. However, no system can guarantee absolute security.</p>
    
    <h2>7. Changes to This Policy</h2>
    <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page, so please check back periodically.</p>
    
    <h2>8. Contact Us</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at info@bettersleep.ing</p>

                            </section>
                        )}
                        {modalContent === 'terms' && (
                            <section className="terms-of-service">
                            <h1>Terms of Service</h1>
                            
                            <h2>1. Acceptance of Terms</h2>
                            <p>By accessing or using our website, you agree to be bound by these Terms of Service. If you do not agree, please do not use our website.</p>
                            
                            <h2>2. Changes to Terms</h2>
                            <p>We reserve the right to modify these terms at any time. Your continued use of the site after changes are posted constitutes your acceptance of the new terms.</p>
                            
                            <h2>3. Use of Website</h2>
                            <p>You agree to use the website for lawful purposes only. You may not use it to distribute spam, viruses, or other harmful material.</p>
                            
                            <h2>4. Intellectual Property</h2>
                            <p>All content on this website, including text, images, and logos, is owned by us or our content partners. Unauthorized use of this material is prohibited.</p>
                            
                            <h2>5. Limitation of Liability</h2>
                            <p>We are not liable for any damages arising from your use of the website or inability to access it. We provide the website "as is" without warranties of any kind.</p>
                            
                            <h2>6. Termination</h2>
                            <p>We reserve the right to terminate or suspend access to our website at our sole discretion, without prior notice.</p>
                            
                            <h2>7. Governing Law</h2>
                            <p>These terms are governed by and construed in accordance with the laws of the United Kingdom.</p>
                            
                            <h2>8. Contact Us</h2>
                            <p>For any questions regarding these Terms of Service, please contact us at info@bettersleep.ing.</p>
                        </section>
                        )}
                        {modalContent === 'editorial' && (
                            <section className="editorial-standards">
                                <h1>Editorial Standards</h1>
                                <p>BetterSleep publishes practical, evidence-based sleep guidance. Here is how we work and how we keep it trustworthy.</p>
                                <h2>Evidence first</h2>
                                <p>Our articles draw on peer-reviewed research and guidance from bodies such as the Sleep Foundation, NHS, Mayo Clinic and the American Academy of Sleep Medicine, and we cite sources in the text where relevant.</p>
                                <h2>How our content is produced</h2>
                                <p>We use AI-assisted drafting to research and structure articles, and every piece is checked against an editorial quality standard before it is published. We are transparent about this because earning your trust matters more than pretending otherwise.</p>
                                <h2>Corrections</h2>
                                <p>Spotted something inaccurate or out of date? Email info@bettersleep.ing and we will review and update it.</p>
                                <h2>Product recommendations</h2>
                                <p>Some links are affiliate links, which may earn us a commission at no extra cost to you. This never changes our recommendations — we only suggest products where they genuinely help.</p>
                            </section>
                        )}
                        {modalContent === 'disclaimer' && (
                            <section className="medical-disclaimer">
                                <h1>Medical Disclaimer</h1>
                                <p>The information on BetterSleep is provided for general educational purposes only and is not intended as, and shall not be understood or construed as, professional medical advice, diagnosis or treatment.</p>
                                <p>Always seek the advice of your physician or another qualified health provider with any questions you may have regarding a medical condition or your sleep. Never disregard professional medical advice, or delay seeking it, because of something you have read on this website.</p>
                                <p>If you think you may have a medical emergency, contact your doctor or emergency services immediately.</p>
                            </section>
                        )}
                    </div>
                </div>
            )}
        </footer>
    );
};

export default Footer;
